import React from 'react'
import ProgressSkill from '../elements/ProgressSkill'

const SkillSection = () => {
  return (
    <section id="skills" className="skills section ">
      <div className="container section-title" data-aos="fade-up">
        <h2>Habilitades tecnicas</h2>
        <p>Contamos con la capacidad de implementar soluciones con la mejor tecnolog&iacute;a.</p>
      </div>
      <div className="container" data-aos="fade-up" data-aos-delay="100">
        <div className="row skills-content skills-animation">
          <div className="col-lg-6">
            <ProgressSkill skill="HTML" percentage="100%" />
            <ProgressSkill skill="CSS" percentage="90%" />
            <ProgressSkill skill="JavaScript" percentage="85%" />
            <ProgressSkill skill="REACT" percentage="80%" />
          </div>
          <div className="col-lg-6">
            <ProgressSkill skill="PHP" percentage="90%" />
            <ProgressSkill skill="LARAVEL" percentage="90%" />
            <ProgressSkill skill="HOSTING" percentage="85%" />
            <ProgressSkill skill="AWS" percentage="70%" />
          </div>
        </div>
      </div>
    </section>
  )
}

export default SkillSection